<template>
  <div id="sub-banner-image-container">
    <!-- <img src="../assets/banner.jpg" alt="Detail from glass mosque lamp of knotwork design"> -->
    <img
      v-show="imageURL.length > 0"
      :src="imageURL"
      :alt="`Detail from ${objectInfo.name}`"
    />
    <div id="sub-banner-overlay">
      <div id="sub-banner-overlay-text">{{ header }}</div>
      <div id="sub-banner-copyright" v-show="objectInfoLoaded && !lessThan724">
        <span
          id="sub-banner-copyright-name"
          v-html="`Detail from ${objectInfo.name}`"
        ></span>
        <span
          ><span v-if="objectInfo.partnerName"
            >{{ objectInfo.partnerName }}, </span
          >{{ objectInfo.location }}, {{ objectInfo.countryName }}</span
        >
      </div>
    </div>
  </div>
</template>



<script>
import banners from "../mixins/banners.js";
import media from "../mixins/media.js";
export default {
  name: "SubBanner",
  mixins: [banners, media],
  data() {
    return {
      lessThan724: window.matchMedia("(max-width: 724px)").matches,
      header: "",
      imageURL: "",
      objectURL: "",
      objectInfo: {},
      objectInfoLoaded: false,
    };
  },
  watch: {
    $route() {
      this.setHeader(this.$route.path);
    },
  },
  methods: {
    setHeader: function (route) {
      if (route === "/collection" || route === "/collection-results") {
        this.header = "Collection";
      } else if (route.includes("/database-item") || route === "/search") {
        this.header = "Database";
      } else if (
        route === "/partners" ||
        route.includes("/partner") ||
        route.includes("/partner-objects")
      ) {
        this.header = "Partners & Contributors";
      } else if (
        route === "/timeline" ||
        route === "/timeline-results" ||
        route.includes("/timeline-gallery")
      ) {
        this.header = "Timeline";
      } else if (route === "/about") {
        this.header = "About";
      } else if (route === "/credits") {
        this.header = "Credits";
      } else if (route === "/error") {
        this.header = "Error";
      }
    },
  },
  mounted() {
    this.getBannerLinks().then(() => {
      this.checkIE("sub-banner-image-container");
    });
    this.setHeader(this.$route.path);
  },
};
</script>



<style scoped lang="scss">
#sub-banner-image-container {
  position: relative;
  height: 20vh;
  min-height: 50px;
  max-height: 150px;
  width: 100%;
}
#sub-banner-image-container img {
  @include image-scale;
  @include sub-banner-placement;
  object-fit: cover;
}
#sub-banner-overlay {
  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  min-height: 50px;
  width: 100%;
  background-color: rgba($theme-dark, 0.6);
}
#sub-banner-overlay-text {
  font-size: 190%;
  color: white;
  padding: 10px 10px 10px 50px;
}
#sub-banner-copyright {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: inherit;
  color: rgba(255, 255, 255, 0.8);
  font-size: 90%;
  font-style: italic;
  padding-right: 50px;
}
#sub-banner-copyright-name {
  font-weight: bold;
}

/* IE-only */
@media only screen and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  #sub-banner-image-container {
    @include ie-sub-banner-placement;
    background-size: cover;
  }
  #sub-banner-image-container img {
    display: none;
  }
}

@media only screen and (max-width: 1199px) {
  #sub-banner-overlay-text {
    font-size: 170%;
  }
}

@media only screen and (max-width: 849px) {
  #sub-banner-overlay-text {
    font-size: 155%;
  }
}

@media only screen and (max-width: 724px) {
  #sub-banner-image-container {
    max-height: 100px;
  }
  #sub-banner-overlay {
    min-height: 40px;
  }
  #sub-banner-overlay-text {
    font-size: 145%;
    padding: 5px 5px 5px 50px;
  }
}

@media only screen and (max-width: 599px) {
  #sub-banner-image-container {
    max-height: 80px;
  }
  #sub-banner-overlay {
    min-height: 35px;
  }
  #sub-banner-overlay-text {
    font-size: 130%;
    padding: 5px 5px 5px 30px;
  }
}

@media print {
  #sub-banner-image-container {
    display: none;
  }
}
</style>